import { render, staticRenderFns } from "./UserSessions.vue?vue&type=template&id=e2de84c6&"
import script from "./UserSessions.vue?vue&type=script&lang=js&"
export * from "./UserSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports